import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/contexts/AuthContext';
import { sessionConfig } from '@/config/session';
import { ClockIcon, ArrowRightOnRectangleIcon } from '@/icons';

/** Current session info + sign-out. Reflects the client idle policy. */
export function SessionSection() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const idleMin = Math.round(sessionConfig.idleTimeoutMs / 60_000);

  const signOut = async () => { await logout(); navigate('/login', { replace: true }); };

  return (
    <Card className="max-w-2xl">
      <CardHeader title="Session" description="How your session behaves in this browser." />
      <CardBody>
        <div className="flex items-start gap-3 rounded-lg border border-border p-4">
          <ClockIcon className="mt-0.5 h-5 w-5 text-fg-subtle" />
          <div>
            <p className="text-sm font-medium text-fg">Automatic sign-out</p>
            <p className="text-sm text-fg-muted">You'll be signed out after {idleMin} minutes of inactivity. Your session is kept fresh automatically while you're active.</p>
          </div>
        </div>
        <div className="mt-4">
          <Button color="danger" variant="flat" startContent={<ArrowRightOnRectangleIcon className="h-4 w-4" />} onPress={signOut}>
            Sign out of this session
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
